import React from 'react';
import { useExperienceScreen } from '../screen/use-experience-screen';

export const MassEditModalsContext = React.createContext({});

export const useMassEditModalsState = () => {
    const { selectedCourses = [] } = useExperienceScreen();
    const [ modalVisible, setModalVisible ] = React.useState({ });

    const showModalComponent = (modalComponent) => setModalVisible({ modalComponent });
    const { modalComponent } = modalVisible;
    const closeModal = () => showModalComponent();

    const hasSelectedCourses = selectedCourses.length;

    return {
        hasSelectedCourses,
        selectedCourses,
        showModalComponent,
        modalComponent,
        closeModal
    };
};

export const useMassEditModals = () => React.useContext(MassEditModalsContext);